import React from 'react';

import { kebabCase } from 'lodash';

import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';

import classes from './CustomizedTabs.module.scss';

export interface ITab<T> {
    value: T;
    label: React.ReactNode;
    disabled?: boolean;
    tooltip?: React.ReactNode;
}

export interface ICustomizedTabsProps<T> {
    tabs: ITab<T>[];
    activeTab: T;
    setActiveTab: (value: T) => void;
    containerClass?: string;
    wrapperClass?: string;
}

export const CustomizedTabs = <T extends string>({
    tabs,
    activeTab,
    setActiveTab,
    containerClass,
    wrapperClass,
}: ICustomizedTabsProps<T>) => {
    const onClick = (item, isDisabled) => {
        if (isDisabled) {
            return false;
        }
        item.value && setActiveTab(item.value);
    };

    return tabs.length > 0 ? (
        <div data-testid={'customized-tabs'} className={`${classes.tabsContainer} ${containerClass ?? ''}`}>
            {tabs.map((item, index) => {
                const isActiveTab = activeTab === item.value;
                const isDisabled = item.hasOwnProperty('disabled') && item.disabled;

                return item.tooltip ? (
                    <div
                        data-testid={'tab number' + index}
                        data-track-id={kebabCase(`tab-${item.value}`)}
                        className={`${classes.tabWrapper} ${isActiveTab ? classes.active : ''} ${isDisabled ? classes.disabled : ''} ${wrapperClass ?? ''}`}
                        key={index}
                        onClick={() => {
                            onClick(item, isDisabled);
                        }}
                    >
                        <CustomizedTooltip
                            tooltipPosition={TooltipPosition.Center}
                            tooltipContent={item.tooltip}
                            triggerElement={item.label}
                        />
                    </div>
                ) : (
                    <div
                        data-testid={'tab number' + index}
                        data-track-id={kebabCase(`tab-${item.value}`)}
                        className={`${classes.tabWrapper} ${isActiveTab ? classes.active : ''} ${isDisabled ? classes.disabled : ''} ${wrapperClass ?? ''}`}
                        key={index}
                        onClick={() => {
                            onClick(item, isDisabled);
                        }}
                    >
                        {item.label}
                    </div>
                );
            })}
        </div>
    ) : null;
};
